import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { SkeletonLoaderComponent } from "./skeleton-loader.component";

@NgModule({
  declarations:[SkeletonLoaderComponent],
  exports:[SkeletonLoaderComponent],
  imports:[NgxSkeletonLoaderModule,CommonModule],
})
export class SkeletonLoaderModule{
  constructor(){

  }
}
